import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Input,
  QueryList,
  inject,
  signal,
} from '@angular/core';

import { NavbarBrandOptionComponent } from './navbar-brand-option/navbar-brand-option.component';
import { NavbarService } from './navbar.service';

export type VudNavbarType = 'default' | 'secondary';

@Component({
  selector: 'di-navbar',
  templateUrl: './navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'vudNavbar',
  standalone: false,
  host: {
    class: 'tw:relative tw:flex',
  },
})
export class NavbarComponent {
  private readonly navbarService = inject(NavbarService);

  @Input() type: VudNavbarType = 'default';
  @Input() collapseOnSelect = false;

  readonly isBurgerMenuBpMatched$ = this.navbarService.isBurgerMenuBpMatched$;

  /**
   * @ignore
   * @deprecated use your own breakpoint system to handle the use of this utility breakpoint
   */
  readonly isTablet$ = this.navbarService.isTablet$;

  readonly collapseSignal = signal(0);

  @ContentChildren(NavbarBrandOptionComponent, { descendants: true })
  readonly brandOptions?: QueryList<NavbarBrandOptionComponent>;

  isBurgerMenuBpMatched(): boolean {
    return this.navbarService.isBurgerMenuBpMatched();
  }

  onMobileMenuItemSelected(): void {
    if (this.collapseOnSelect && this.isBurgerMenuBpMatched()) {
      this.collapseSignal.update((v) => v + 1);
    }
  }
}
